export default __webpack_public_path__ + "static/media/u12.73266ce5.png";